module.exports = __webpack_public_path__ + "img/icon16.636779c3.png";